import { useNavigate, Link } from 'react-router-dom';
import { heroBanner } from '../assets/images';

function Hero() {
  const navigate = useNavigate();
  const heroVideoUrl =
    'https://cdn.prod.website-files.com/6719ad0ceed6d5aa24a83d61%2F696ecc1f3ff5304a4fb2789b_Hero-video%20%281%29_mp4.mp4';

  return (
    <section className="hero hero-cinematic" id="home" aria-label="Introduction">
      <div className="hero-bg-media" aria-hidden="true">
        <video
          className="hero-bg-video"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={heroBanner}
        >
          <source src={heroVideoUrl} type="video/mp4" />
        </video>
        <div className="hero-bg-fallback" style={{ backgroundImage: `url(${heroBanner})` }}></div>
      </div>

      <div className="hero-overlay-layer" aria-hidden="true"></div>

      <div className="container hero-shell">
        <div className="hero-content">
          <p className="hero-eyebrow">QASHQ BUSINESS &amp; IT CONSULTANTS</p>

          <h1 className="hero-title">Smarter Decisions. Stronger Business.</h1>

          <p className="hero-text">
            Business and IT consulting solutions designed to help businesses operate smarter,
            grow faster, and build for the future.
          </p>

          <div className="hero-actions">
            <Link to="/contact" className="btn btn-secondary hero-primary-btn">
              Get a Free Consultation
            </Link>
            <button
              type="button"
              className="btn btn-outline-light hero-secondary-btn"
              onClick={() => navigate('/services')}
            >
              Explore Our Services
            </button>
          </div>

          <ul className="hero-trust-list" aria-label="Core capabilities">
            <li>Business Advisory</li>
            <li>Accounting &amp; Compliance</li>
            <li>IT Consulting</li>
            <li>Digital Solutions</li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default Hero;
